import Lenis from "lenis";
import "lenis/dist/lenis.css";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

class LenisSmoothScroll {
  constructor(options = {}) {
    this.lerp = options.lerp ?? 0.5;
    this.wheelMultiplier = options.wheelMultiplier ?? 1;
    this.mediaQuery =
      options.mediaQuery || "(hover: hover) and (pointer: fine)";
    this.lenis = null;
    this.matchMedia = null;
    this.handleTicker = this.handleTicker.bind(this);

    this.init();
  }

  init() {
    this.matchMedia = gsap.matchMedia();

    this.matchMedia.add(this.mediaQuery, () => {
      this.create();

      return () => {
        this.destroyLenis();
      };
    });
  }

  create() {
    if (this.lenis) return;

    this.lenis = new Lenis({
      lerp: this.lerp,
      smoothWheel: true,
      wheelMultiplier: this.wheelMultiplier,
      syncTouch: false,
      anchors: true,
      autoRaf: false,
    });

    this.lenis.on("scroll", ScrollTrigger.update);

    gsap.ticker.add(this.handleTicker);
    gsap.ticker.lagSmoothing(0);

    ScrollTrigger.refresh();
  }

  handleTicker(time) {
    if (!this.lenis) return;

    this.lenis.raf(time * 1000);
  }

  destroyLenis() {
    gsap.ticker.remove(this.handleTicker);

    if (!this.lenis) return;

    this.lenis.destroy();
    this.lenis = null;

    ScrollTrigger.refresh();
  }

  destroy() {
    this.destroyLenis();

    if (this.matchMedia) {
      this.matchMedia.revert();
      this.matchMedia = null;
    }
  }
}

export default LenisSmoothScroll;
